<template>
<div>
      <div style="padding-bottom:10px">
      <i class="fas fa-arrow-left" style="border:1px solid #ccc;padding:10px;cursor:pointer" @click="goback"> </i>
    <span style="font-size:24px;font-weight:500"> Create Deals</span>
    </div>

    <form @submit.prevent="handleSubmit4">
  <CCard>
    <CCardBody>
      <CRow>
        <div class="col-8">
<div class="form-group">
           <label for="value">Discount code</label>
          <input
            type="text"
            placeholder="Discount Code"
            id="quantity"
            class="form-control"
            v-model="discode"
          />

        </div>

        </div>
        <div class="col-2">
<CButton @click="generate"  style="position:relative;top:2.5rem" color="danger">Generate Code</CButton>
        </div>
              </CRow>
        <CRow>

          <div class="col-8">
            <div style="form-input">
              <label>Types</label>
              <b-form-select
                v-model="discount.type"
                :options="types"
                class="form-input"
                value-field="item"
                text-field="name"
                disabled-field="notEnabled"
                
              >
              </b-form-select>
            </div>
          </div>
        </CRow>
        <div class="form-group" v-if="discount.type == 'fixedAmount'">
          <label for="value">Value</label>
          <!-- <span class="symbol">{{ business.symbol }}</span> -->
          <input
            type="text"
            placeholder="00.00"
            style="width: 50%"
            id="quantity"
            class="form-control"
            v-model="discount.fixedamount"
          />
                 </div>
        <div class="form-group" v-if="discount.type == 'percent'">
          <label for="value">Value</label>
          <!-- <span class="symbol">{{ business.symbol }}</span> -->
          <input
            type="text"
            placeholder="%"
            style="width: 50%"
            id="quantity"
            class="form-control"
            v-model="discount.Percentage"
          />
        </div>
         <div>
            <b-form-group label="Applies to" v-if="discount.type == 'percent' || discount.type=='fixedAmount'">
              <b-form-radio
                v-model="selected"
                name="some-radios"
                checked
                v-on:change="deliver"
                value=" All Products"
                >All Products
              </b-form-radio>
              <b-form-radio
                v-model="selected"
                name="some-radios"
                value="catalog"
                v-on:change="deliver0"
                >Specific Catalog
                <div v-if="show == 'catalog' && selected == 'catalog'">
                  <CCard>
                    <CCardHeader
                      @click="cardCollapse = !cardCollapse"
                      class="btn text-left"
                    >
                      Selected Catalog({{ selected_meals.length }})
                    </CCardHeader>
                    <CCollapse :show="cardCollapse">
                      <CCardBody class="m-1">
                        <div
                          class="panel panel-default"
                          v-for="choice in catalog_data"
                          v-bind:key="choice"
                        >
                          <div class="panel-heading">
                            <input
                              type="checkbox"
                              v-bind:id="choice"
                              v-bind:value="choice"
                              v-model="selected_meals"
                            />
                            &nbsp;{{ choice }}
                          </div>
                        </div>
                      </CCardBody>
                    </CCollapse>
                  </CCard>
                </div>
              </b-form-radio>

              <b-form-radio
                v-model="selected"
                name="some-radios"
                value="product"
                v-on:change="deliver2"
                >Specific Product
                <div v-if="show == 'product' && selected == 'product'">
                  <CCard>
                    <CCardHeader
                      @click="collapse = !collapse"
                      class="btn text-left"
                    >
                      Selected Product({{ selected_product.length }})
                    </CCardHeader>
                    <CCollapse :show="collapse">
                      <CCardBody class="m-1">
                        <div
                          class="panel panel-default"
                          v-for="choice1 in product_data"
                          v-bind:key="choice1"
                        >
                          <div class="panel-heading">
                            <input
                              type="checkbox"
                              v-bind:id="choice1"
                              v-bind:value="choice1"
                              v-model="selected_product"
                            />
                            &nbsp;{{ choice1 }}
                          </div>
                        </div>
                      </CCardBody>
                    </CCollapse>
                  </CCard>
                </div>
              </b-form-radio>
            </b-form-group>
          </div>

        <div class="form-group" v-if="discount.type == 'freeship'">
          <b-form-group label="Countries">
            <b-form-radio
              v-model="selectedcoun"
              name="some-radios2"
              checked
              v-on:change="delivercoun"
              value="allcountry"
              >All Countries
            </b-form-radio>
            <b-form-radio
              v-model="selectedcoun"
              name="some-radios2"
              value="speccountry"
              v-on:change="deliver0coun"
              >Specific Country
              <div
                v-if="
                  showcoun == 'speccountry' && selectedcoun == 'speccountry'
                "
              >
                <CCard>
                  <CCardHeader
                    @click="cardCollapsecountry = !cardCollapsecountry"
                    class="btn text-left"
                  >
                    Selected Country({{ selected_country.length }})
                  </CCardHeader>
                  <CCollapse :show="cardCollapsecountry">
                    <CCardBody class="m-1">
                      <div
                        class="panel panel-default"
                        v-for="choicecoun in countries"
                        v-bind:key="choicecoun"
                      >
                        <div class="panel-heading">
                          <input
                            type="checkbox"
                            v-bind:id="choicecoun"
                            v-bind:value="choicecoun"
                            v-model="selected_country"
                          />
                          &nbsp;{{ choicecoun.name }}
                        </div>
                      </div>
                    </CCardBody>
                  </CCollapse>
                </CCard>
              </div>
            </b-form-radio>
          </b-form-group>
          <b-form-checkbox v-model="discount.shipping"
            >Exclude shipping rates over a certain amount
            <input
              type="text"
              v-if="discount.shipping"
              style="width: 50%"
              id="quantity"
              class="form-control"
              name="pincode"
              v-model="discount.shippingrate"
            />
          </b-form-checkbox>
        </div>
        <div v-if="discount.type != 'buyxgety'">
          <b-form-group label="Minimum requirements">
            <b-form-radio
              v-model="selectedmin"
              name="some-radios1"
              checked
              v-on:change="deliverreq"
              value="None"
              >None
            </b-form-radio>
            <b-form-radio
              v-model="selectedmin"
              name="some-radios1"
              value="miniamount"
              v-on:change="deliver0req"
              >Minimum purchase amount (₹)
              <div
                v-if="showmin == 'miniamount' && selectedmin == 'miniamount'"
              >
                <input
                  type="text"
                  style="width: 50%"
                  id="quantity"
                  class="form-control"
                  name="pincode"
                  min="1"
                  max="50"
                  v-model="discount.minimumamount"
                />
                <p>Applies only to selected collections.</p>
              </div>
            </b-form-radio>

            <b-form-radio
              v-model="selectedmin"
              name="some-radios1"
              value="minireq"
              v-on:change="deliver2req"
              >Minimum quantity of items

              <div v-if="showmin == 'minireq' && selectedmin == 'minireq'">
                <input
                  type="text"
                  style="width: 50%"
                  id="quantity"
                  class="form-control"
                  name="pincode"
                  min="1"
                  max="50"
                  v-model="discount.minimumquantity"
                />
                <p>Applies only to selected collections.</p>
              </div>
            </b-form-radio>
          </b-form-group>
          <!-- https://chronotruck.github.io/vue-ctk-date-time-picker/ -->
        </div>
        <div></div>
                <div class="form-group" v-if="discount.type == 'buyxgety'">
          <b-form-group label="Customer Spends">
            <b-form-radio
              v-model="selectedcus"
              name="some-radios3"
              checked
              v-on:change="delivercus"
              value="minquan"
              >Minimum quantity of items
            </b-form-radio>
            <b-form-radio
              v-model="selectedcus"
              name="some-radios3"
              value="minpurchase"
              v-on:change="deliver0cus"
              >Minimum purchase amount
            </b-form-radio>

            <div class="row">
              <div class="col">
                <div class="form-group" v-if="showcus=='minquan' && selectedcus == 'minquan'">
                  <label for="value">Quantity</label>
                  <!-- <span class="symbol">{{ business.symbol }}</span> -->
                  <input
                    type="text"
                    id="quantity"
                    class="form-control"
                    v-model="discount.customerquantity"
                  />
                </div>
                <div class="form-group" v-if="showcus=='minpurchase' && selectedcus == 'minpurchase'">
                  <label for="value">Amount</label>
                  <!-- <span class="symbol">{{ business.symbol }}</span> -->
                  <input
                    type="text"
                    placeholder="00.00"
                    id="quantity"
                    class="form-control"
                    v-model="discount.customeramount"
                  />
                </div>
              </div>
              <div class="col" style="padding-top:15px">
                  <label>Any Item From</label>
                    <b-form-select v-model="selectedcusblw" >
      <b-form-select-option value="product">Specific Product</b-form-select-option>
      <b-form-select-option value="Catalog" >Specific Catalog</b-form-select-option>
    </b-form-select>
                </div>
                                <div class="form-group" v-if="selectedcusblw == 'Catalog'">
                  <CCard>
                    <CCardHeader
                      @click="cardcustomercat = !cardcustomercat"
                      class="btn text-left"
                    >
                      Selected Catalog({{ selected_customercatalog.length }})
                    </CCardHeader>
                    <CCollapse :show="cardcustomercat">
                      <CCardBody class="m-1">
                        <div
                          class="panel panel-default"
                          v-for="choice3 in catalog_data"
                          v-bind:key="choice3"
                        >
                          <div class="panel-heading">
                            <input
                              type="checkbox"
                              v-bind:id="choice3"
                              v-bind:value="choice3"
                              v-model="selected_customercatalog"
                            />
                            &nbsp;{{ choice3 }}
                          </div>
                        </div>
                      </CCardBody>
                    </CCollapse>
                  </CCard>
                </div>
  <div class="form-group" v-if="selectedcusblw == 'product'">
                 <CCard>
                    <CCardHeader
                      @click="collapse = !collapse"
                      class="btn text-left"
                    >
                      Selected Product({{ selected_product.length }})
                    </CCardHeader>
                    <CCollapse :show="collapse">
                      <CCardBody class="m-1">
                        <div
                          class="panel panel-default"
                          v-for="choice1 in product_data"
                          v-bind:key="choice1"
                        >
                          <div class="panel-heading">
                            <input
                              type="checkbox"
                              v-bind:id="choice1"
                              v-bind:value="choice1"
                              v-model="selected_product"
                            />
                            &nbsp;{{ choice1 }}
                          </div>
                        </div>
                      </CCardBody>
                    </CCollapse>
                  </CCard>
                </div>
              </div>
          </b-form-group>



           <b-form-group label="Customer gets">

            <div class="row">
              <div class="col">
                <div class="form-group">
                  <label for="value">Quantity</label>
                  <!-- <span class="symbol">{{ business.symbol }}</span> -->
                  <input
                    type="text"
                    id="quantity"
                    class="form-control"
                    v-model="discount.customergetquantity"
                  />
                </div>
              </div>
              <div class="col" style="padding-top:15px">
                  <label>Any Item From</label>
                    <b-form-select v-model="selectedcusgetblw" >
      <b-form-select-option value="productget">Specific Product</b-form-select-option>
      <b-form-select-option value="Catalogget" >Specific Catalog</b-form-select-option>
    </b-form-select>
                </div>
                                <div class="form-group" v-if="selectedcusgetblw == 'Catalogget'">
                  <CCard>
                    <CCardHeader
                      @click="cardcustomercatget = !cardcustomercatget"
                      class="btn text-left"
                    >
                      Selected Catalog({{ selected_customercatalogget.length }})
                    </CCardHeader>
                    <CCollapse :show="cardcustomercatget">
                      <CCardBody class="m-1">
                        <div
                          class="panel panel-default"
                          v-for="choice31 in catalog_data"
                          v-bind:key="choice31"
                        >
                          <div class="panel-heading">
                            <input
                              type="checkbox"
                              v-bind:id="choice31"
                              v-bind:value="choice31"
                              v-model="selected_customercatalogget"
                            />
                            &nbsp;{{ choice31 }}
                          </div>
                        </div>
                      </CCardBody>
                    </CCollapse>
                  </CCard>
                </div>
  <div class="form-group" v-if="selectedcusgetblw == 'productget'">
                 <CCard>
                    <CCardHeader
                      @click="collapseget = !collapseget"
                      class="btn text-left"
                    >
                      Selected Product({{ selected_productget.length }})
                    </CCardHeader>
                    <CCollapse :show="collapseget">
                      <CCardBody class="m-1">
                        <div
                          class="panel panel-default"
                          v-for="choice12 in product_data"
                          v-bind:key="choice12"
                        >
                          <div class="panel-heading">
                            <input
                              type="checkbox"
                              v-bind:id="choice12"
                              v-bind:value="choice12"
                              v-model="selected_productget"
                            />
                            &nbsp;{{ choice12 }}
                          </div>
                        </div>
                      </CCardBody>
                    </CCollapse>
                  </CCard>
                </div>
              </div>
          </b-form-group>
        </div>

        <div class="form-group">
          <p>Usage limits</p>
          <b-form-checkbox v-model="discount.limitdiscount"
            >Limit number of times this discount can be used in total
            <input
              type="text"
              v-if="discount.limitdiscount"
              style="width: 50%"
              id="quantity"
              class="form-control"
              name="pincode"
              v-model="discount.limdiscount"
            />
          </b-form-checkbox>
          <b-form-checkbox v-model="discount.limitCustomer"
            >Limit to one use per customer
          </b-form-checkbox>
        </div>
        <!-- <div class="form-group">
                        <label>Discount Code</label>
                        <input type="button" value="Generate Coupon" id="button" @click="populateform(discount.thelength.value);">
<input type="hidden" name="thelength" size=3 value="6" >     
<input name="COUPON" type="text" id="COUPON" size="20" maxlength="20">
                        
                      </div> -->
        <div class="form-group">
          <p>Active Dates</p>
          <div class="row">
            <div class="col">
              <label for="startdate">Start Date</label>
              <input
                type="date"
                v-model="discount.startdate"
                id="startdate"
                name="startdate"
                class="form-control"
              />
            </div>
            <div class="col">
              <label for="fromTime">Start Time</label>
              <input
                type="time"
                v-model="discount.fromTime"
                id="fromTime"
                name="fromTime"
                class="form-control"
              />
            </div>
          </div>
        </div>
  <CCardFooter>
<button
                        class="
                          btn btn-danger btn-login
                          fw-bold
                          mb-2
                        "
                        type="submit"
                        style="border-radius: 3rem; float: right"
                      >
                        Save & Submit
                        <b-spinner
                          v-if="dealsload"
                          small
                          type="grow"
                        ></b-spinner>
                      </button>
            </CCardFooter>
      </CCardBody
  ></CCard>
        </form> 

</div>
    
</template>
<script src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.3.1/jquery.min.js"></script>
<script>
import firebase from "firebase";
import { uuid } from "vue-uuid";
import VueToast from "vue-toast-notification";
import { required, email, minLength, sameAs } from "vuelidate/lib/validators";
import "vue-toast-notification/dist/theme-sugar.css";
Vue.use(VueToast, {
  // One of the options
  position: "top-right",
});

export default {
  components: {},
  data() {
    return {
      discode:"",
      cardCollapse: false,
      collapse: false,
      collapseget:false,
      cardCollapsecountry: false,
      cardcustomercat:false,
      cardcustomercatget:false,
      dealsload:false,
      selected_country: [],
      selectedcusgetblw:'',
      selected_customercatalog:[],
      selected_customercatalogget:[],
      selectedcus: "",
      selected: "",
      showcus:'',
      selectedcoun: "",
      show: "",
      showcoun: "",
      selectedmin: "",
      showmin: "",
      selected_meals: [],
      selected_product: [],
      selected_productget:[],
      catalog_data: [],
      product_data: [],
      submitted: false,
      expanded: false,
      discount: {},
      selectedcusblw:'',
      countries: [
        { name: "Afghanistan", code: "AF" },
        { name: "land Islands", code: "AX" },
        { name: "Albania", code: "AL" },
        { name: "Algeria", code: "DZ" },
        { name: "American Samoa", code: "AS" },
        { name: "AndorrA", code: "AD" },
        { name: "Angola", code: "AO" },
        { name: "Anguilla", code: "AI" },
        { name: "Antarctica", code: "AQ" },
        { name: "Antigua and Barbuda", code: "AG" },
        { name: "Argentina", code: "AR" },
        { name: "Armenia", code: "AM" },
        { name: "Aruba", code: "AW" },
        { name: "Australia", code: "AU" },
        { name: "Austria", code: "AT" },
        { name: "Azerbaijan", code: "AZ" },
        { name: "Bahamas", code: "BS" },
        { name: "Bahrain", code: "BH" },
        { name: "Bangladesh", code: "BD" },
        { name: "Barbados", code: "BB" },
        { name: "Belarus", code: "BY" },
        { name: "Belgium", code: "BE" },
        { name: "Belize", code: "BZ" },
        { name: "Benin", code: "BJ" },
        { name: "Bermuda", code: "BM" },
        { name: "Bhutan", code: "BT" },
        { name: "Bolivia", code: "BO" },
        { name: "Bosnia and Herzegovina", code: "BA" },
        { name: "Botswana", code: "BW" },
        { name: "Bouvet Island", code: "BV" },
        { name: "Brazil", code: "BR" },
        { name: "British Indian Ocean Territory", code: "IO" },
        { name: "Brunei Darussalam", code: "BN" },
        { name: "Bulgaria", code: "BG" },
        { name: "Burkina Faso", code: "BF" },
        { name: "Burundi", code: "BI" },
        { name: "Cambodia", code: "KH" },
        { name: "Cameroon", code: "CM" },
        { name: "Canada", code: "CA" },
        { name: "Cape Verde", code: "CV" },
        { name: "Cayman Islands", code: "KY" },
        { name: "Central African Republic", code: "CF" },
        { name: "Chad", code: "TD" },
        { name: "Chile", code: "CL" },
        { name: "China", code: "CN" },
        { name: "Christmas Island", code: "CX" },
        { name: "Cocos (Keeling) Islands", code: "CC" },
        { name: "Colombia", code: "CO" },
        { name: "Comoros", code: "KM" },
        { name: "Congo", code: "CG" },
        { name: "Congo, The Democratic Republic of the", code: "CD" },
        { name: "Cook Islands", code: "CK" },
        { name: "Costa Rica", code: "CR" },
        { name: 'Cote D"Ivoire', code: "CI" },
        { name: "Croatia", code: "HR" },
        { name: "Cuba", code: "CU" },
        { name: "Cyprus", code: "CY" },
        { name: "Czech Republic", code: "CZ" },
        { name: "Denmark", code: "DK" },
        { name: "Djibouti", code: "DJ" },
        { name: "Dominica", code: "DM" },
        { name: "Dominican Republic", code: "DO" },
        { name: "Ecuador", code: "EC" },
        { name: "Egypt", code: "EG" },
        { name: "El Salvador", code: "SV" },
        { name: "Equatorial Guinea", code: "GQ" },
        { name: "Eritrea", code: "ER" },
        { name: "Estonia", code: "EE" },
        { name: "Ethiopia", code: "ET" },
        { name: "Falkland Islands (Malvinas)", code: "FK" },
        { name: "Faroe Islands", code: "FO" },
        { name: "Fiji", code: "FJ" },
        { name: "Finland", code: "FI" },
        { name: "France", code: "FR" },
        { name: "French Guiana", code: "GF" },
        { name: "French Polynesia", code: "PF" },
        { name: "French Southern Territories", code: "TF" },
        { name: "Gabon", code: "GA" },
        { name: "Gambia", code: "GM" },
        { name: "Georgia", code: "GE" },
        { name: "Germany", code: "DE" },
        { name: "Ghana", code: "GH" },
        { name: "Gibraltar", code: "GI" },
        { name: "Greece", code: "GR" },
        { name: "Greenland", code: "GL" },
        { name: "Grenada", code: "GD" },
        { name: "Guadeloupe", code: "GP" },
        { name: "Guam", code: "GU" },
        { name: "Guatemala", code: "GT" },
        { name: "Guernsey", code: "GG" },
        { name: "Guinea", code: "GN" },
        { name: "Guinea-Bissau", code: "GW" },
        { name: "Guyana", code: "GY" },
        { name: "Haiti", code: "HT" },
        { name: "Heard Island and Mcdonald Islands", code: "HM" },
        { name: "Holy See (Vatican City State)", code: "VA" },
        { name: "Honduras", code: "HN" },
        { name: "Hong Kong", code: "HK" },
        { name: "Hungary", code: "HU" },
        { name: "Iceland", code: "IS" },
        { name: "India", code: "IN" },
        { name: "Indonesia", code: "ID" },
        { name: "Iran, Islamic Republic Of", code: "IR" },
        { name: "Iraq", code: "IQ" },
        { name: "Ireland", code: "IE" },
        { name: "Isle of Man", code: "IM" },
        { name: "Israel", code: "IL" },
        { name: "Italy", code: "IT" },
        { name: "Jamaica", code: "JM" },
        { name: "Japan", code: "JP" },
        { name: "Jersey", code: "JE" },
        { name: "Jordan", code: "JO" },
        { name: "Kazakhstan", code: "KZ" },
        { name: "Kenya", code: "KE" },
        { name: "Kiribati", code: "KI" },
        { name: 'Korea, Democratic People"S Republic of', code: "KP" },
        { name: "Korea, Republic of", code: "KR" },
        { name: "Kuwait", code: "KW" },
        { name: "Kyrgyzstan", code: "KG" },
        { name: 'Lao People"S Democratic Republic', code: "LA" },
        { name: "Latvia", code: "LV" },
        { name: "Lebanon", code: "LB" },
        { name: "Lesotho", code: "LS" },
        { name: "Liberia", code: "LR" },
        { name: "Libyan Arab Jamahiriya", code: "LY" },
        { name: "Liechtenstein", code: "LI" },
        { name: "Lithuania", code: "LT" },
        { name: "Luxembourg", code: "LU" },
        { name: "Macao", code: "MO" },
        { name: "Macedonia, The Former Yugoslav Republic of", code: "MK" },
        { name: "Madagascar", code: "MG" },
        { name: "Malawi", code: "MW" },
        { name: "Malaysia", code: "MY" },
        { name: "Maldives", code: "MV" },
        { name: "Mali", code: "ML" },
        { name: "Malta", code: "MT" },
        { name: "Marshall Islands", code: "MH" },
        { name: "Martinique", code: "MQ" },
        { name: "Mauritania", code: "MR" },
        { name: "Mauritius", code: "MU" },
        { name: "Mayotte", code: "YT" },
        { name: "Mexico", code: "MX" },
        { name: "Micronesia, Federated States of", code: "FM" },
        { name: "Moldova, Republic of", code: "MD" },
        { name: "Monaco", code: "MC" },
        { name: "Mongolia", code: "MN" },
        { name: "Montenegro", code: "ME" },
        { name: "Montserrat", code: "MS" },
        { name: "Morocco", code: "MA" },
        { name: "Mozambique", code: "MZ" },
        { name: "Myanmar", code: "MM" },
        { name: "Namibia", code: "NA" },
        { name: "Nauru", code: "NR" },
        { name: "Nepal", code: "NP" },
        { name: "Netherlands", code: "NL" },
        { name: "Netherlands Antilles", code: "AN" },
        { name: "New Caledonia", code: "NC" },
        { name: "New Zealand", code: "NZ" },
        { name: "Nicaragua", code: "NI" },
        { name: "Niger", code: "NE" },
        { name: "Nigeria", code: "NG" },
        { name: "Niue", code: "NU" },
        { name: "Norfolk Island", code: "NF" },
        { name: "Northern Mariana Islands", code: "MP" },
        { name: "Norway", code: "NO" },
        { name: "Oman", code: "OM" },
        { name: "Pakistan", code: "PK" },
        { name: "Palau", code: "PW" },
        { name: "Palestinian Territory, Occupied", code: "PS" },
        { name: "Panama", code: "PA" },
        { name: "Papua New Guinea", code: "PG" },
        { name: "Paraguay", code: "PY" },
        { name: "Peru", code: "PE" },
        { name: "Philippines", code: "PH" },
        { name: "Pitcairn", code: "PN" },
        { name: "Poland", code: "PL" },
        { name: "Portugal", code: "PT" },
        { name: "Puerto Rico", code: "PR" },
        { name: "Qatar", code: "QA" },
        { name: "Reunion", code: "RE" },
        { name: "Romania", code: "RO" },
        { name: "Russian Federation", code: "RU" },
        { name: "RWANDA", code: "RW" },
        { name: "Saint Helena", code: "SH" },
        { name: "Saint Kitts and Nevis", code: "KN" },
        { name: "Saint Lucia", code: "LC" },
        { name: "Saint Pierre and Miquelon", code: "PM" },
        { name: "Saint Vincent and the Grenadines", code: "VC" },
        { name: "Samoa", code: "WS" },
        { name: "San Marino", code: "SM" },
        { name: "Sao Tome and Principe", code: "ST" },
        { name: "Saudi Arabia", code: "SA" },
        { name: "Senegal", code: "SN" },
        { name: "Serbia", code: "RS" },
        { name: "Seychelles", code: "SC" },
        { name: "Sierra Leone", code: "SL" },
        { name: "Singapore", code: "SG" },
        { name: "Slovakia", code: "SK" },
        { name: "Slovenia", code: "SI" },
        { name: "Solomon Islands", code: "SB" },
        { name: "Somalia", code: "SO" },
        { name: "South Africa", code: "ZA" },
        { name: "South Georgia and the South Sandwich Islands", code: "GS" },
        { name: "Spain", code: "ES" },
        { name: "Sri Lanka", code: "LK" },
        { name: "Sudan", code: "SD" },
        { name: "Suriname", code: "SR" },
        { name: "Svalbard and Jan Mayen", code: "SJ" },
        { name: "Swaziland", code: "SZ" },
        { name: "Sweden", code: "SE" },
        { name: "Switzerland", code: "CH" },
        { name: "Syrian Arab Republic", code: "SY" },
        { name: "Taiwan, Province of China", code: "TW" },
        { name: "Tajikistan", code: "TJ" },
        { name: "Tanzania, United Republic of", code: "TZ" },
        { name: "Thailand", code: "TH" },
        { name: "Timor-Leste", code: "TL" },
        { name: "Togo", code: "TG" },
        { name: "Tokelau", code: "TK" },
        { name: "Tonga", code: "TO" },
        { name: "Trinidad and Tobago", code: "TT" },
        { name: "Tunisia", code: "TN" },
        { name: "Turkey", code: "TR" },
        { name: "Turkmenistan", code: "TM" },
        { name: "Turks and Caicos Islands", code: "TC" },
        { name: "Tuvalu", code: "TV" },
        { name: "Uganda", code: "UG" },
        { name: "Ukraine", code: "UA" },
        { name: "United Arab Emirates", code: "AE" },
        { name: "United Kingdom", code: "GB" },
        { name: "United States", code: "US" },
        { name: "United States Minor Outlying Islands", code: "UM" },
        { name: "Uruguay", code: "UY" },
        { name: "Uzbekistan", code: "UZ" },
        { name: "Vanuatu", code: "VU" },
        { name: "Venezuela", code: "VE" },
        { name: "Viet Nam", code: "VN" },
        { name: "Virgin Islands, British", code: "VG" },
        { name: "Virgin Islands, U.S.", code: "VI" },
        { name: "Wallis and Futuna", code: "WF" },
        { name: "Western Sahara", code: "EH" },
        { name: "Yemen", code: "YE" },
        { name: "Zambia", code: "ZM" },
        { name: "Zimbabwe", code: "ZW" },
      ],
            types: [
        { item: "percent", name: "Percentage" },
        { item: "fixedAmount", name: "Fixed amount" },
        { item: "freeship", name: "Free shipping" },
        { item: "buyxgety", name: "Buy X get Y" },
      ],

    };
  },
  validations: {
    // discount: {
    //   types: { required },
    // },
  },
  methods: {
    handleSubmit4(e){
      this.dealsload=true;
            const db = firebase.firestore();
      db.collection("discount")
        .add({
          type: this.discount.type,
          fixedamount: this.discount.type =='fixedAmount'?this.discount.fixedamount:'',
          appliesTo:{
            selected:this.selected,
            items:this.selected_meals==[]?this.selected_product:[]
          },
          discode:this.discode,
          percentage:this.discount.type == 'percent'?this.discount.percentage:'',
          minimumRequirement:{
selected:this.selectedmin,
purchaseAmount:this.selectedmin=='miniamount'?this.discount.minimumamount:'',
quantity:this.selectedmin=='minireq'?this.discount.minimumquantity:''
          },
          id: firebase.auth().currentUser.uid,
          startTime:this.discount.startdate!=''?this.discount.startdate:'',
          FromTime:this.discount.fromTime!=''?this.discount.fromTime:'',
          usageLimit:this.discount.limitdiscount==true?this.discount.limdiscount:'',
          limitcustomer:this.discount.limitCustomer==true?this.discount.limitCustomer:false,
          countries:{
            selected:this.selectedcoun,
            specificCountry:this.selected_country!=[]?this.selected_country:[]
          }

        })
        .then(() => {
          this.dealsload = false;
          Vue.$toast.success("Deals added successfully!", {
            // override the global option
            position: "top-right",
          });

          // this.$router.push("/discounts");
        })
        .catch((error) => {
          console.log(error);
          Vue.$toast.error(error.message, {
            // override the global option
            position: "top-right",
          });
        });

    },goback(){
                      this.$router.push("/dealslist");

    },
    generate(){
      function makeid(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * 
 charactersLength));
   }
   return result;
}

this.discode=makeid(6).toUpperCase();
console.log(this.discode)
    },
    delivercoun($event) {
      this.selected_country = [];
    },
    delivercus($event) {
            this.showcus = $event;

    },
    deliver0cus($event) {
      this.showcus = $event;
    },
    deliver0coun($event) {
      this.showcoun = $event;
      console.log(this.showcoun);
    },

    deliver($event) {
      console.log($event);

      this.selected_meals = [];
      this.selected_product = [];
    },
    deliver2req($event) {
      this.showmin = $event;
      this.discount.minimumamount = "";
    },
    deliverreq($event) {
      this.discount.minimumamount = "";
      this.discount.minimumquantity = "";
    },
    deliver0req($event) {
      console.log($event);
      this.showmin = $event;
      this.discount.minimumquantity = "";
    },

    deliver2($event) {
      this.show = $event;
      this.selected_meals = [];
    },
    deliver0($event) {
      this.show = $event;
      this.selected_product = [];
    },
    getcatalogList() {
      const db = firebase.firestore();
      db.collection("catalog")
        .where("id", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.catalog_data.push(doc.data().name);
          });
          console.log("catalog", this.catalog_data);
        });
    },
    getProductlist() {
      const db = firebase.firestore();
      db.collection("products")
        .where("id", "==", firebase.auth().currentUser.uid)
        .get()
        .then((snapshot) => {
          snapshot.forEach((doc) => {
            this.product_data.push(doc.data().name);
          });
          console.log("products", this.product_data);
        });
    },
  },
  mounted() {
    this.getcatalogList();
    this.getProductlist();
  },
  Created() {},
};
</script>
<style scoped>
</style>